module.exports = __webpack_public_path__ + "static/img/recruitOne.4a6da99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageFour/recruitOne.png
// module id = 1Jb8
// module chunks = 0